import filter from "./modules/filter";
import {initSliderApartment} from "./modules/slider";
import {catalogMap} from './modules/map';

filter();
initSliderApartment();
catalogMap();